export default "__VITE_ASSET__BhJqw8ZB__"